module.exports = __webpack_public_path__ + "static/media/FFlogo-svart.8b26b948.svg";